export const sar = (v) => `${Number(v || 0).toLocaleString("en-US", { maximumFractionDigits: 0 })} ر.س`;
export const MONTHS_AR = ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"];
export const monthLabel = (ym) => MONTHS_AR[Number((ym || "").slice(5, 7)) - 1] || ym;
export const EMERGENT_CAT = "Emergent (تطوير المنصة)";
